export default [
  {
    path: '/user-inviting-data',
    name: 'user-inviting-data.index',
    component: require('./index').default,
    meta: {
      title: '用户销售额',
      navbar: 'el-icon-data-analysis'
    }
  }
]
